import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tickets-new-ticket',
  templateUrl: './tickets-new-ticket.component.html',
  styleUrls: ['./tickets-new-ticket.component.scss']
})
export class TicketsNewTicketComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
